import { render, staticRenderFns } from "./abastecimento.vue?vue&type=template&id=6b62331a"
import script from "./abastecimento.vue?vue&type=script&lang=js"
export * from "./abastecimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports